import { ConfigStateService, PermissionService } from '@abp/ng.core';
import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { PermissionConstants } from 'src/core/constants/permission.constant';

@Injectable({ providedIn: 'root' })
export class AgentStatusAccessService {
  private readonly configState = inject(ConfigStateService);
  private readonly permissionService = inject(PermissionService);

  private readonly permissionGranted = toSignal(
    this.configState.getAll$().pipe(
      filter(config => !!config?.currentUser),
      map(() => this.permissionService.getGrantedPolicy(PermissionConstants.canViewAgentDesktop)),
    ),
    { initialValue: false },
  );

  readonly isEnabled = computed(() => this.permissionGranted());

  canUseStatusManagement(): boolean {
    return this.isEnabled();
  }
}
